
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vmc-validator",
      function () {
        return require("private-next-pages/vmc-validator.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vmc-validator"])
      });
    }
  